import { t } from "@/i18n-js/instance";
import { useSupportWidgetContext } from "@circle-react/components/SupportWidget/SupportWidgetContext";
import { ErrorDetails } from "./ErrorDetails";

type SupportType = "email" | "chat";
type IconColor = "red" | "grey";

interface ContactSupportProps {
  errorMessage?: string;
  hideModal?: () => void;
  iconColor?: IconColor;
  supportType?: SupportType;
  title: string;
}

export const ContactSupport = ({
  title,
  errorMessage,
  iconColor = "red",
  supportType = "email",
  hideModal,
}: ContactSupportProps) => {
  const { toggleWidget } = useSupportWidgetContext();

  const handleEmailSupport = () => {
    window.open("mailto:support@circle.so", "emailWindow");
  };

  const handleSupport = () => {
    if (supportType === "chat") {
      hideModal?.();
      toggleWidget();
    } else {
      handleEmailSupport();
    }
  };

  return (
    <ErrorDetails
      title={title}
      errorMessage={errorMessage}
      buttonLabel={t("pricing_plans.upgrade_modal.actions.contact_support")}
      onClick={handleSupport}
      iconColor={iconColor}
    />
  );
};
